function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var _Symbol$for, _Symbol$for2;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

import ee from 'namespace-emitter';

var _queued = /*#__PURE__*/_classPrivateFieldLooseKey("queued");

var _emitter = /*#__PURE__*/_classPrivateFieldLooseKey("emitter");

var _isOpen = /*#__PURE__*/_classPrivateFieldLooseKey("isOpen");

var _socket = /*#__PURE__*/_classPrivateFieldLooseKey("socket");

var _handleMessage = /*#__PURE__*/_classPrivateFieldLooseKey("handleMessage");

_Symbol$for = Symbol.for('uppy test: getSocket');
_Symbol$for2 = Symbol.for('uppy test: getQueued');

var UppySocket = /*#__PURE__*/function (_Symbol$for3, _Symbol$for4) {
  function UppySocket(opts) {
    var _this = this;

    _classCallCheck(this, UppySocket);

    Object.defineProperty(this, _queued, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _emitter, {
      writable: true,
      value: ee()
    });
    Object.defineProperty(this, _isOpen, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _socket, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _handleMessage, {
      writable: true,
      value: function value(e) {
        try {
          var message = JSON.parse(e.data);

          _this.emit(message.action, message.payload);
        } catch (err) {
          // TODO: use a more robust error handler.
          console.log(err); // eslint-disable-line no-console
        }
      }
    });
    this.opts = opts;

    if (!opts || opts.autoOpen !== false) {
      this.open();
    }
  }

  _createClass(UppySocket, [{
    key: "isOpen",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _isOpen)[_isOpen];
    }
  }, {
    key: _Symbol$for3,
    value: function value() {
      return _classPrivateFieldLooseBase(this, _socket)[_socket];
    }
  }, {
    key: _Symbol$for4,
    value: function value() {
      return _classPrivateFieldLooseBase(this, _queued)[_queued];
    }
  }, {
    key: "open",
    value: function open() {
      var _this2 = this;

      if (_classPrivateFieldLooseBase(this, _socket)[_socket] != null) return;
      _classPrivateFieldLooseBase(this, _socket)[_socket] = new WebSocket(this.opts.target);

      _classPrivateFieldLooseBase(this, _socket)[_socket].onopen = function () {
        _classPrivateFieldLooseBase(_this2, _isOpen)[_isOpen] = true;

        while (_classPrivateFieldLooseBase(_this2, _queued)[_queued].length > 0 && _classPrivateFieldLooseBase(_this2, _isOpen)[_isOpen]) {
          var first = _classPrivateFieldLooseBase(_this2, _queued)[_queued].shift();

          _this2.send(first.action, first.payload);
        }
      };

      _classPrivateFieldLooseBase(this, _socket)[_socket].onclose = function () {
        _classPrivateFieldLooseBase(_this2, _isOpen)[_isOpen] = false;
        _classPrivateFieldLooseBase(_this2, _socket)[_socket] = null;
      };

      _classPrivateFieldLooseBase(this, _socket)[_socket].onmessage = _classPrivateFieldLooseBase(this, _handleMessage)[_handleMessage];
    }
  }, {
    key: "close",
    value: function close() {
      var _classPrivateFieldLoo;

      (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _socket)[_socket]) == null ? void 0 : _classPrivateFieldLoo.close();
    }
  }, {
    key: "send",
    value: function send(action, payload) {
      // attach uuid
      if (!_classPrivateFieldLooseBase(this, _isOpen)[_isOpen]) {
        _classPrivateFieldLooseBase(this, _queued)[_queued].push({
          action: action,
          payload: payload
        });

        return;
      }

      _classPrivateFieldLooseBase(this, _socket)[_socket].send(JSON.stringify({
        action: action,
        payload: payload
      }));
    }
  }, {
    key: "on",
    value: function on(action, handler) {
      _classPrivateFieldLooseBase(this, _emitter)[_emitter].on(action, handler);
    }
  }, {
    key: "emit",
    value: function emit(action, payload) {
      _classPrivateFieldLooseBase(this, _emitter)[_emitter].emit(action, payload);
    }
  }, {
    key: "once",
    value: function once(action, handler) {
      _classPrivateFieldLooseBase(this, _emitter)[_emitter].once(action, handler);
    }
  }]);

  return UppySocket;
}(_Symbol$for, _Symbol$for2);

export { UppySocket as default };